import {Page} from 'Core/models/Page';

export type PagedViewLoadNextProps<TData> = {
  data: Page<TData>;
  stop: number;
  start: number;
  pagedViewKey: string;
  loadMore: (page: Page<TData>) => void;
  RECORDS_PER_PAGE: number;
  PAGE_LIMIT: number;
  dispatch: any;
  changeMaxPage: any;
};

export const PagedViewLoadNext = <TData extends {}>(info: PagedViewLoadNextProps<TData>) => {
  if (info.stop > info.data.result.length && info.start < info.data.totalCount) {
    // As of now PageLimit check is applied only to accounts
    if (info.pagedViewKey !== 'accounts') {
      info.loadMore(info.data);
    } else if (info.start < info.RECORDS_PER_PAGE * info.PAGE_LIMIT) {
      info.dispatch(info.changeMaxPage(false));
      info.loadMore(info.data);
    } else {
      info.dispatch(info.changeMaxPage(true));
    }
  }
  return true;
};

export default PagedViewLoadNext;
